import type { RouteRecordRaw } from 'vue-router';
import communitiesMessageBoardRoutes from '@/modules/communities-message-board/routes';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'communities',
    meta: {
      permissions: [Permission.ClientsCommunitiesMessageboardView],
    },
    children: [
      {
        path: '',
        name: 'client-community-onboarding',
        component: () => import('./JoinCommunity.vue'),
      },
      {
        path: ':communityId',
        children: [
          {
            path: '',
            name: 'client-community',
            component: () => import('./CommunityPage.vue'),
            props: true,
          },
          ...communitiesMessageBoardRoutes,
        ],
      },
    ],
  },
] satisfies RouteRecordRaw[];
